export const baseApiUrl = window.__RUNTIME_CONFIG__.BASE_API_URL;
export const countryCode = window.__RUNTIME_CONFIG__.COUNTRY_CODE;

export const downloadUrlConfigTemplate = window.__RUNTIME_CONFIG__.DOWNLOAD_URL_CONFIG_TEMPLATE;
export const downloadUrlBootstrapUltra = window.__RUNTIME_CONFIG__.DOWNLOAD_URL_BOOTSTRAP_ULTRA;
export const downloadUrlPrepareHome = window.__RUNTIME_CONFIG__.DOWNLOAD_URL_PREPARE_HOME;

export const awsAuthRegion = window.__RUNTIME_CONFIG__.AWSAUTH_REGION;
export const awsAuthUserPoolId = window.__RUNTIME_CONFIG__.AWSAUTH_USERPOOLID;
export const awsAuthClientId = window.__RUNTIME_CONFIG__.AWSAUTH_CLIENTID;
export const awsAuthDomain = window.__RUNTIME_CONFIG__.AWSAUTH_DOMAIN;
export const awsAuthScopes = window.__RUNTIME_CONFIG__.AWSAUTH_SCOPES;
export const awsAuthSignInUrl = window.__RUNTIME_CONFIG__.AWSAUTH_SIGNINURL;
export const awsAuthSignOutUrl = window.__RUNTIME_CONFIG__.AWSAUTH_SIGNOUTURL;
export const awsAuthDebug = window.__RUNTIME_CONFIG__.AWSAUTH_DEBUG;

export const isAwsAuthDebug = (): boolean => {
  return awsAuthDebug != undefined && awsAuthDebug.toLowerCase() == 'true';
};
